'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Path prefixes that use bg-surface-2 for the main content area.
 * All other routes use bg-surface-1.
 */
const SURFACE_2_PATHS = [
  '/courses',
  '/learning-paths'
];

function useMainBackground(): 'bg-surface-1' | 'bg-surface-2' {
  const pathname = usePathname() ?? '';
  const [bgClass, setBgClass] = useState<'bg-surface-1' | 'bg-surface-2'>('bg-surface-1');

  useEffect(() => {
    const useSurface2 = SURFACE_2_PATHS.some((path) =>
      pathname === path || pathname.startsWith(`${path}/`)
    );
    setBgClass(useSurface2 ? 'bg-surface-2' : 'bg-surface-1');
  }, [pathname]);

  return bgClass;
}

export function MainWithBackground({
  children,
}: {
  children: React.ReactNode;
}) {
  const bgClass = useMainBackground();
  return <main className={`${bgClass} relative z-10`}>{children}</main>;
}
